import { RootState } from '@app/store';
import { StationsState } from '@app/store/data/Stations';
import { getDataState } from '@app/store/globals';

/* **************************************** *
 *    Export globalized state selectors     *
 * **************************************** */
export const getStationsState = (state: RootState): StationsState => getDataState(state).stations;
